import { trackInAdobe } from './service/adobe.js';
export { DISCOUNT_TYPE, EXPERIMENT_TOOL, FEE_TYPE, PLATFORM_TYPE, TRACKING_EVENT, TRACKING_PAGE } from './constants.js';

const trackEvent = (event) => {
    if (typeof window !== 'undefined') {
        trackInAdobe(event);
    }
};

export { trackEvent };
//# sourceMappingURL=index.js.map
